import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { FormControlsTitle, InputMaskTitle } from "../../../../../constants";
import { InputMasksSubTitle } from "../../../../../data/formsAndTable/forms/FormControls";
import DateFormat from "./DateFormat";
import DefaultInputMask from "./DefaultInputMask";
import TimeFormat from "./TimeFormat";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const InputMaskContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={InputMaskTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card>
              <CommonCardHeader title={InputMaskTitle} span={InputMasksSubTitle} />
              <CardBody  className="input-mask">
                <Row className="g-3">
                  <DateFormat />
                  <TimeFormat />
                  <DefaultInputMask />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default InputMaskContainer;
